import { makeStyles } from '@mui/styles'
import { BORDERRADIUS as borderRadius } from "@fedsim/constants"

import { sharedGenericStyling } from './shared'

export const useAvatarStyles = makeStyles(theme => {
  return {
    ...sharedGenericStyling,
    list: {
      ...sharedGenericStyling.list,
      overflow: 'hidden',
      margin: 0,
      padding: 0,
      display: 'grid',
      gridColumn: 2,
      gap: `${theme.spacing(1)}`,
      // gridTemplateColumns: `repeat(auto-fit, minmax(150px, auto))`
      // want grid template columns but equl width
      gridTemplateColumns: `repeat(auto-fit, minmax(150px, 1fr))`
    },
    listitem: {
      listStyle: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    arrangement: {
      padding: theme.spacing(0.5),
      width: "100%",
      maxWidth: '300px'
    },
    avatar: {
      borderRadius,
      minWidth: "100px"
    },
    chip: {
      textOverflow: 'ellipsis',
      textAlign: 'left',
      padding: theme.spacing(1),
      borderRadius
    },
    selected: {
      margin: theme.spacing(0.6, 0)
    }
  }
})
